import { QueryResult, useQuery } from '@apollo/client';
import GET_USAGE_ERRORS from '../api/getUsageErrors';
import type { UsageErrorsData, UsageRangeVariables } from '../types';

/**
 * RITA-1505 (Nutzungserfassung Phase 2c) — häufigste Fehlermeldungen, eigene Operation.
 *
 * Gleiche Optionen wie useUsageInsights (Begründung dort). Getrennt, damit der Abschnitt
 * „Fehler“ einen eigenen Lade- und Fehlerzustand hat: sein Fenster endet an der Rohdatenfrist
 * und ist deshalb kürzer als das der verdichteten Kennzahlen.
 */
export const useUsageErrors = (days: number): QueryResult<UsageErrorsData, UsageRangeVariables> =>
  useQuery<UsageErrorsData, UsageRangeVariables>(GET_USAGE_ERRORS, {
    variables: { range: { days } },
    fetchPolicy: 'network-only',
    errorPolicy: 'none',
    notifyOnNetworkStatusChange: true,
  });

export default useUsageErrors;
